import $ from "jquery";

import { findWidgetForElement } from "./Util.ts";

function findInplaceWidget(event: JQuery.TriggeredEvent): PrimeFaces.widget.Inplace | undefined {
  const element = $(event.target);
  const inplace = element.closest(".ui-inplace");
  return findWidgetForElement(inplace, PrimeFaces.widget.Inplace);
}

export function onEditorKeyDown(event: JQuery.TriggeredEvent): void {
  const widget = findInplaceWidget(event);
  if (widget !== undefined) {
    if (event.key === "Enter") {
      widget.save();
      event.preventDefault();
    } else if (event.key === "Escape") {
      widget.cancel();
      event.preventDefault();
    }
  }
}

export function onEditorBlur(event: JQuery.TriggeredEvent): void {
  const widget = findInplaceWidget(event);
  widget?.save();
}
